/*
* @描述: 订单代采明细
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025-02-08 15:37:55
*/
<template>
    <div>
        <el-dialog :before-close="handleDialogClose"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :visible.sync="dialogVisible"
                   class="custom_form_dialog purchase_detail_dialog"
                   title="代采明细"
                   width="800px">
            <div class="ta_r mb_16">
                <el-button v-if="order_detail.order_status===1"
                           size="small"
                           type="primary"
                           @click="handleClickAddPurchase">新增代采
                </el-button>
            </div>
            <vxe-table v-loading="loading" :data="purchaseList" border height="570">
                <vxe-column title="代采编号" width="180">
                    <template #default="{ row }">
                        <el-tooltip :content="row.cancel_reason"
                                    effect="dark"
                                    placement="top">
                        <span v-if="row.status === 4"
                              class="handle_icon_wrap handle_icon_danger_wrap cancel_icon">
                            <i class="iconfont icon-guanbi1"></i>
                        </span>
                        </el-tooltip>
                        <span class="link-label" @click="handleClickPurchaseDetail(row)"
                              v-text="row.purchase_num"></span>
                    </template>
                </vxe-column>
                <vxe-column title="代采发起人" width="100">
                    <template #default="{ row }">
                        <div class="custom_contact_field_wrap">
                            <PersonnelCard :userId="row.uid">
                                <template slot="container">
                                    <img :src="row.user_avatar || defaultImg" alt=""
                                         class="avatar">
                                    <span class="name" v-text="row.user_name"></span>
                                </template>
                            </PersonnelCard>
                        </div>
                    </template>
                </vxe-column>
                <vxe-column field="created_at" title="代采时间"></vxe-column>
                <vxe-column align="right" title="实际代采金额" width="120">
                    <template #default="{ row }">
                        <div v-text="'¥'+Number(row.actual_total_price).toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})"></div>
                    </template>
                </vxe-column>
                <vxe-column title="状态" width="80">
                    <template #default="{ row }">
                        <div :class="'purchase_status_name_'+row.status"
                             class="purchase_status_name"
                             v-text="row.status_name"></div>
                    </template>
                </vxe-column>
                <vxe-column title="操作" width="97">
                    <template #default="{ row }">
                        <div v-if="order_detail.order_status===1">
                            <el-link v-if="row.status===0"
                                     :underline="false"
                                     type="danger"
                                     @click="handleClickRevokePurchase(row)">撤销
                            </el-link>
                            <el-link v-if="row.status===1" :underline="false" type="primary"
                                     @click="handleClickEditPurchase(row)">编辑
                            </el-link>
                            <span v-if="row.status===1" class="line"></span>
                            <el-link v-if="row.status===1" :underline="false" type="danger"
                                     @click="handleClickInvalidate(row)">作废
                            </el-link>
                            <el-link v-if="row.status===2||row.status===4"
                                     :underline="false"
                                     type="primary"
                                     @click="handleClickResubmit(row)">重新提交
                            </el-link>
                        </div>
                    </template>
                </vxe-column>
            </vxe-table>
            <el-dialog v-if="addPurchaseDialog"
                       :before-close="handleClickAddPurchaseCancel"
                       :close-on-click-modal="false"
                       :close-on-press-escape="false"
                       :visible.sync="addPurchaseDialog"
                       append-to-body
                       class="custom_form_dialog purchase_detail_dialog"
                       title="新增代采"
                       width="620px">
                <el-form ref="purchaseForm"
                         :model="purchaseForm"
                         label-position="top"
                         size="small">
                    <el-form-item>
                        <ul class="purchase_table_list">
                            <li v-for="(item,index) in purchaseForm.purchase_details" class="purchase_details_item">
                                <div class="purchase_details_item_index">
                                    <span v-text="'代采' + (index+1)"></span>
                                    <span v-if="purchaseForm.purchase_details.length>1"
                                          class="handle_icon_wrap handle_icon_danger_wrap"
                                          @click="handleClickDelPurchaseDetails(index)">
                                    <i class="iconfont icon-shanchu1"></i>
                                </span>
                                </div>
                                <div class="purchase_details_item_content">
                                    <el-form :model="item"
                                             label-position="top"
                                             size="small">
                                        <el-form-item label="供应商（个人或公司名称）" prop="supplier">
                                            <el-input v-model="item.supplier"
                                                      maxlength="521"
                                                      placeholder="请输入供应商名称"></el-input>
                                        </el-form-item>
                                        <ul class="goods_details_list">
                                            <li v-for="(goods,goods_index) in item.goods_details"
                                                class="goods_details_item">
                                                <div class="goods_details_index">
                                                    <span v-text="'产品明细' + (goods_index+1)"></span>
                                                    <span v-if="item.goods_details.length>1"
                                                          class="handle_icon_wrap handle_icon_danger_wrap"
                                                          @click="item.goods_details.splice(goods_index,1)">
                                                        <i class="el-icon-remove"></i>
                                                    </span>
                                                </div>
                                                <div class="goods_details_content">
                                                    <el-form :ref="'goods_details_form_' + index + '_' + goods_index"
                                                             :model="goods"
                                                             :rules="purchaseFormRules"
                                                             label-position="top"
                                                             size="small">
                                                        <el-form-item label="产品名称" prop="goods_name">
                                                            <el-input v-model="goods.goods_name"
                                                                      placeholder="请输入产品名称"></el-input>
                                                        </el-form-item>
                                                        <el-form-item label="单价" prop="price">
                                                            <el-input v-model="goods.price"
                                                                      placeholder="请输入单价"
                                                                      @blur="handleGoodsPriceBlur(goods,item)"></el-input>
                                                        </el-form-item>
                                                        <el-form-item label="数量" prop="num">
                                                            <el-input-number v-model="goods.num"
                                                                             :controls="false"
                                                                             :min="0"
                                                                             placeholder="请输入数量"
                                                                             type="number"
                                                                             @blur="handleGoodsNumBlur(goods,item)">
                                                            </el-input-number>
                                                        </el-form-item>
                                                        <el-form-item label="产品总价" prop="subtotal_price">
                                                            <el-input v-model="goods.subtotal_price" disabled
                                                                      placeholder="自动算出"></el-input>
                                                        </el-form-item>
                                                    </el-form>
                                                </div>
                                            </li>
                                        </ul>
                                        <div class="add_purchase_details_btn"
                                             @click="handleClickAddPurchaseDetails(item)">
                                            <i class="el-icon-plus"></i>
                                            <span>添加明细</span>
                                        </div>
                                    </el-form>
                                </div>
                            </li>
                        </ul>
                        <div class="add_purchase_btn" @click="handleClickAddPurchaseList">
                            <i class="el-icon-plus"></i>
                            <span>添加代采</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="代采产品总金额" prop="total_price">
                        <el-input v-model="purchaseForm.total_price" disabled
                                  placeholder="自动算出"></el-input>
                    </el-form-item>
                    <el-form-item label="总优惠金额" prop="discount_price">
                        <el-input v-model="purchaseForm.discount_price"
                                  placeholder="请输入总优惠金额"
                                  @blur="handleDiscountPriceBlur"></el-input>
                    </el-form-item>
                    <el-form-item label="实际代采总金额">
                        <el-input v-model="purchaseForm.actual_total_price" disabled
                                  placeholder="自动算出"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" prop="remarks">
                        <el-input v-model="purchaseForm.remarks"
                                  :rows="5"
                                  maxlength="255"
                                  placeholder="请输入备注"
                                  type="textarea"></el-input>
                    </el-form-item>
                    <el-form-item label="附件">
                        <div class="file_upload_wrap">
                            <div v-if="purchaseForm.file.length===0" class="file_outer_wrap">
                                <img alt=""
                                     src="https://download.hecoos.com/enlightv/2023-31/3wy8ZnscPAjXMD2XmQhb.png"
                                     width="36">
                                <p class="file_hint">点击或者将文件拖拽到这里上传</p>
                                <p class="file_type_hint">支持Word、Excel、PDF等常见类型</p>
                                <input class="upload_input"
                                       multiple
                                       type="file"
                                       @change="handleUploadFileChange($event)">
                            </div>
                            <ul v-else class="upload_file_list">
                                <li v-for="(file,file_idx) in purchaseForm.file" class="upload_file_item">
                                    <div class="file_left_wrap">
                                        <img alt="" class="file_img"
                                             src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png">
                                        <div class="file_info_wrap">
                                            <p class="file_name" v-text="file.file_name"></p>
                                            <p class="file_size" v-text="file.file_size"></p>
                                        </div>
                                    </div>
                                    <div class="file_right_wrap">
                                        <el-tooltip content="预览"
                                                    effect="dark"
                                                    placement="top">
                                            <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                <i class="iconfont icon-yanjing"></i>
                                            </span>
                                        </el-tooltip>
                                        <span class="line"></span>
                                        <el-tooltip content="删除"
                                                    effect="dark"
                                                    placement="top">
                                            <span class="handle_icon_wrap handle_icon_danger_wrap"
                                                  @click="purchaseForm.file.splice(file_idx,1)">
                                                <i class="iconfont icon-shanchu1"></i>
                                            </span>
                                        </el-tooltip>
                                    </div>
                                </li>
                                <li class="upload_file_btn_wrap">
                                    <i class="el-icon-plus"></i>
                                    <span>上传附件</span>
                                    <input class="upload_input"
                                           multiple
                                           type="file"
                                           @change="handleUploadFileChange($event)">
                                </li>
                            </ul>
                        </div>
                    </el-form-item>
                </el-form>
                <div v-if="purchaseForm.order_price_change.length">
                    <div class="page_little_title">
                        <span class="title">订单金额变更信息</span>
                        <span class="hint"> 审批通过后（无需审批请忽略），以下订单金额将变更</span>
                    </div>
                    <ul class="order_price_change_list">
                        <li v-for="item in purchaseForm.order_price_change" class="order_price_change_item">
                            <div class="field_name" v-text="item.field_name"></div>
                            <div>
                                <span class="value_text"
                                      v-text="item.old_value.text?'¥' + item.old_value.text:'--'"></span>
                                <i class="iconfont icon-youjiantou"></i>
                                <span class="value_text" v-text="'¥' + item.new_value.text"></span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div v-if="isApproval===1" class="add_approval_select_process">
                    <div class="page_little_title">
                        <span class="title">审批流程</span>
                    </div>
                    <approveProcessSelect ref="approveProcessSelectRef"
                                          :approval_node_list="purchaseForm.node_list">
                    </approveProcessSelect>
                </div>
                <div slot="footer">
                    <el-button size="small" @click="handleClickAddPurchaseCancel">取消</el-button>
                    <el-button size="small" type="primary" @click="handleClickAddPurchaseConfirm">确定</el-button>
                </div>
            </el-dialog>
            <el-dialog v-if="editPurchaseDialog"
                       :before-close="handleClickEditPurchaseCancel"
                       :close-on-click-modal="false"
                       :close-on-press-escape="false"
                       :visible.sync="editPurchaseDialog"
                       append-to-body
                       class="custom_form_dialog purchase_detail_dialog"
                       title="编辑代采"
                       width="620px">
                <el-form ref="purchaseForm"
                         :model="purchaseForm"
                         label-position="top"
                         size="small">
                    <el-form-item>
                        <ul class="purchase_table_list">
                            <li v-for="(item,index) in purchaseForm.purchase_details" class="purchase_details_item">
                                <div class="purchase_details_item_index">
                                    <span v-text="'代采' + (index+1)"></span>
                                    <span v-if="purchaseForm.purchase_details.length>1"
                                          class="handle_icon_wrap handle_icon_danger_wrap"
                                          @click="handleClickDelPurchaseDetails(index)">
                                    <i class="iconfont icon-shanchu1"></i>
                                </span>
                                </div>
                                <div class="purchase_details_item_content">
                                    <el-form :model="item"
                                             label-position="top"
                                             size="small">
                                        <el-form-item label="供应商（个人或公司名称）" prop="supplier">
                                            <el-input v-model="item.supplier"
                                                      maxlength="521"
                                                      placeholder="请输入供应商名称"></el-input>
                                        </el-form-item>
                                        <ul class="goods_details_list">
                                            <li v-for="(goods,goods_index) in item.goods_details"
                                                class="goods_details_item">
                                                <div class="goods_details_index">
                                                    <span v-text="'产品明细' + (goods_index+1)"></span>
                                                    <span v-if="item.goods_details.length>1"
                                                          class="handle_icon_wrap handle_icon_danger_wrap"
                                                          @click="item.goods_details.splice(goods_index,1)">
                                                        <i class="el-icon-remove"></i>
                                                    </span>
                                                </div>
                                                <div class="goods_details_content">
                                                    <el-form :ref="'goods_details_form_' + index + '_' + goods_index"
                                                             :model="goods"
                                                             :rules="purchaseFormRules"
                                                             label-position="top"
                                                             size="small">
                                                        <el-form-item label="产品名称" prop="goods_name">
                                                            <el-input v-model="goods.goods_name"
                                                                      placeholder="请输入产品名称"></el-input>
                                                        </el-form-item>
                                                        <el-form-item label="单价" prop="price">
                                                            <el-input v-model="goods.price"
                                                                      placeholder="请输入单价"
                                                                      @blur="handleGoodsPriceBlur(goods,item)"></el-input>
                                                        </el-form-item>
                                                        <el-form-item label="数量" prop="num">
                                                            <el-input-number v-model="goods.num"
                                                                             :controls="false"
                                                                             :min="0"
                                                                             placeholder="请输入数量"
                                                                             type="number"
                                                                             @blur="handleGoodsNumBlur(goods,item)">
                                                            </el-input-number>
                                                        </el-form-item>
                                                        <el-form-item label="产品总价" prop="subtotal_price">
                                                            <el-input v-model="goods.subtotal_price" disabled
                                                                      placeholder="自动算出"></el-input>
                                                        </el-form-item>
                                                    </el-form>
                                                </div>
                                            </li>
                                        </ul>
                                        <div class="add_purchase_details_btn"
                                             @click="handleClickAddPurchaseDetails(item)">
                                            <i class="el-icon-plus"></i>
                                            <span>添加明细</span>
                                        </div>
                                    </el-form>
                                </div>
                            </li>
                        </ul>
                        <div class="add_purchase_btn" @click="handleClickAddPurchaseList">
                            <i class="el-icon-plus"></i>
                            <span>添加代采</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="代采产品总金额" prop="total_price">
                        <el-input v-model="purchaseForm.total_price" disabled
                                  placeholder="自动算出"></el-input>
                    </el-form-item>
                    <el-form-item label="总优惠金额" prop="discount_price">
                        <el-input v-model="purchaseForm.discount_price"
                                  placeholder="请输入总优惠金额"
                                  @blur="handleDiscountPriceBlur"></el-input>
                    </el-form-item>
                    <el-form-item label="实际代采总金额">
                        <el-input v-model="purchaseForm.actual_total_price" disabled
                                  placeholder="自动算出"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" prop="remarks">
                        <el-input v-model="purchaseForm.remarks"
                                  :rows="5"
                                  maxlength="255"
                                  placeholder="请输入备注"
                                  type="textarea"></el-input>
                    </el-form-item>
                    <el-form-item label="附件">
                        <div class="file_upload_wrap">
                            <div v-if="purchaseForm.file.length===0" class="file_outer_wrap">
                                <img alt=""
                                     src="https://download.hecoos.com/enlightv/2023-31/3wy8ZnscPAjXMD2XmQhb.png"
                                     width="36">
                                <p class="file_hint">点击或者将文件拖拽到这里上传</p>
                                <p class="file_type_hint">支持Word、Excel、PDF等常见类型</p>
                                <input class="upload_input"
                                       multiple
                                       type="file"
                                       @change="handleUploadFileChange($event)">
                            </div>
                            <ul v-else class="upload_file_list">
                                <li v-for="(file,file_idx) in purchaseForm.file" class="upload_file_item">
                                    <div class="file_left_wrap">
                                        <img alt="" class="file_img"
                                             src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png">
                                        <div class="file_info_wrap">
                                            <p class="file_name" v-text="file.file_name"></p>
                                            <p class="file_size" v-text="file.file_size"></p>
                                        </div>
                                    </div>
                                    <div class="file_right_wrap">
                                        <el-tooltip content="预览"
                                                    effect="dark"
                                                    placement="top">
                                            <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                <i class="iconfont icon-yanjing"></i>
                                            </span>
                                        </el-tooltip>
                                        <span class="line"></span>
                                        <el-tooltip content="删除"
                                                    effect="dark"
                                                    placement="top">
                                            <span class="handle_icon_wrap handle_icon_danger_wrap"
                                                  @click="purchaseForm.file.splice(file_idx,1)">
                                                <i class="iconfont icon-shanchu1"></i>
                                            </span>
                                        </el-tooltip>
                                    </div>
                                </li>
                                <li class="upload_file_btn_wrap">
                                    <i class="el-icon-plus"></i>
                                    <span>上传附件</span>
                                    <input class="upload_input"
                                           multiple
                                           type="file"
                                           @change="handleUploadFileChange($event)">
                                </li>
                            </ul>
                        </div>
                    </el-form-item>
                </el-form>
                <div v-if="purchaseForm.order_price_change.length">
                    <div class="page_little_title">
                        <span class="title">订单金额变更信息</span>
                        <span class="hint"> 审批通过后（无需审批请忽略），以下订单金额将变更</span>
                    </div>
                    <ul class="order_price_change_list">
                        <li v-for="item in purchaseForm.order_price_change" class="order_price_change_item">
                            <div class="field_name" v-text="item.field_name"></div>
                            <div>
                                <span class="value_text"
                                      v-text="item.old_value.text?'¥' + item.old_value.text:'--'"></span>
                                <i class="iconfont icon-youjiantou"></i>
                                <span class="value_text" v-text="'¥' + item.new_value.text"></span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div v-if="isApproval===1" class="add_approval_select_process">
                    <div class="page_little_title">
                        <span class="title">审批流程</span>
                    </div>
                    <approveProcessSelect ref="approveProcessSelectRef"
                                          :approval_node_list="purchaseForm.node_list">
                    </approveProcessSelect>
                </div>
                <div slot="footer">
                    <el-button size="small" @click="handleClickEditPurchaseCancel">取消</el-button>
                    <el-button size="small" type="primary" @click="handleClickEditPurchaseConfirm">确定</el-button>
                </div>
            </el-dialog>
            <el-dialog v-if="invalidatePurchaseDialog"
                       :before-close="handleClickInvalidatePurchaseCancel"
                       :close-on-click-modal="false"
                       :close-on-press-escape="false"
                       :visible.sync="invalidatePurchaseDialog"
                       append-to-body
                       class="custom_form_dialog invalidate_purchase_dialog"
                       title="作废"
                       width="520px">
                <div>
                    <span class="invalidate_title">订单金额变更信息</span>
                    <span class="invalidate_text">（作废后，以下订单金额将变更）</span>
                </div>
                <ul class="order_price_change_list">
                    <li v-for="item in purchaseForm.order_price_change" class="order_price_change_item">
                        <div class="field_name" v-text="item.field_name"></div>
                        <div>
                            <span class="value_text" v-text="item.old_value.text?'¥' + item.old_value.text:'--'"></span>
                            <i class="iconfont icon-youjiantou"></i>
                            <span class="value_text" v-text="'¥' + item.new_value.text"></span>
                        </div>
                    </li>
                </ul>
                <div slot="footer">
                    <el-button size="small" @click="handleClickInvalidatePurchaseCancel">取消</el-button>
                    <el-button size="small" type="primary" @click="handleClickInvalidatePurchaseConfirm">确定
                    </el-button>
                </div>
                <div>
                    <span class="invalidate_title">作废原因</span>
                </div>
                <el-input v-model="cancel_reason"
                          :rows="5"
                          placeholder="请输入作废原因"
                          type="textarea"></el-input>
            </el-dialog>
            <el-image ref="preview_img"
                      :preview-src-list="previewImgList"
                      :src="previewImgSrc"
                      style="display:none">
            </el-image>
        </el-dialog>
        <OrderPurchaseDetail v-if="purchaseDetailDialog" :orderPurchaseId="order_purchase_id"
                             :purchaseDetailDialog.sync="purchaseDetailDialog"/>
        <el-image ref="preview_img"
                  :preview-src-list="previewImgList"
                  :src="previewImgSrc"
                  style="display:none">
        </el-image>
    </div>
</template>
<script>
import {
    cancelApproval,
    getApprovalNodes, orderHasAfterSale,
    purchaseAdd,
    purchaseCancel,
    purchaseDetails,
    purchaseEdit,
    purchaseList
} from "@/api";
import {calculate, formatFileSize, getBusinessIsApproval} from "@/utils";
import approveProcessSelect from "@/components/pComponents/approveProcessSelect";
import PersonnelCard from "@/components/pComponents/PersonnelCard";
import OrderPurchaseDetail from "./order_purchase_detail";
import {getOSSData, uploadImg} from "@/utils/uploadOss";

export default {
    name: "purchaseDetail",
    data() {
        return {
            loading: false,
            purchaseList: [],
            addPurchaseDialog: false,
            editPurchaseDialog: false,
            purchaseForm: {
                total_price: '',
                actual_total_price: '',
                discount_price: '',
                remarks: '',
                file: [],
                purchase_details: [
                    {
                        supplier: '',
                        goods_details: [
                            {
                                goods_name: '',
                                price: '',
                                num: undefined,
                                subtotal_price: ''
                            }
                        ],
                        total_amount: ''
                    }
                ],
                order_price_change: [],
                node_list: []
            },
            purchaseFormRules: {
                goods_name: [{required: true, message: '请输入产品名称', trigger: 'blur'}],
                num: [{required: true, message: '请输入数量', trigger: 'blur'}],
            },
            isApproval: 0,
            purchasePrice: 0,
            purchase_total_amount: 0,
            btnDisabled: false,
            defaultImg: require('@/assets/images/default.jpg'),
            order_purchase_id: 0,
            cancel_reason: '',
            invalidatePurchaseDialog: false,
            purchaseDetailDialog: false,
            previewImgList: [],
            previewImgSrc: ''
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        order_id: {
            type: Number,
            default: 0
        },
        order_detail: {
            type: Object,
            default: () => {
                return {}
            }
        },
        order_amount_field: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    components: {approveProcessSelect, PersonnelCard, OrderPurchaseDetail},
    created() {
        this.getPurchaseList()
    },
    mounted() {
    },
    methods: {
        handleDialogClose() {
            this.$emit('update:dialogVisible', false)
        },

        //获取代采列表
        getPurchaseList() {
            this.loading = true
            purchaseList({
                order_id: this.order_id
            }).then(res => {
                if (res.code === 200) {
                    this.loading = false
                    this.purchaseList = res.data
                } else {
                    this.$message.error(res.message)
                }
            })
        },

        //点击代采详情
        handleClickPurchaseDetail(row) {
            this.order_purchase_id = row.order_purchase_id
            this.purchaseDetailDialog = true
        },

        //点击新增代采
        handleClickAddPurchase() {
            orderHasAfterSale({
                order_id: this.order_id
            }).then(res => {
                if (res.code === 200) {
                    if (res.data.isPendingApproval) {
                        this.$message.error(res.data.tips + '，不允许新增')
                    } else {
                        this.addPurchaseDialog = true
                        this.purchase_total_amount = 0
                        this.purchasePrice = parseFloat(this.order_detail.purchase_cost_price)
                        getBusinessIsApproval('order_purchase').then(res => {
                            this.isApproval = res
                            if (this.isApproval === 1) {
                                getApprovalNodes({
                                    approval_type: 'order_purchase',
                                }).then(res => {
                                    if (res.code === 200) {
                                        this.purchaseForm.node_list = res.data
                                        this.$refs.approveProcessSelectRef.set_approval_node_list(res.data)
                                    } else {
                                        this.$message.error(res.message)
                                    }
                                    this.loading = false
                                }).catch(() => {
                                    this.loading = false
                                })
                            }
                        })
                    }
                }
            })
        },

        //新增代采取消事件
        handleClickAddPurchaseCancel() {
            this.addPurchaseDialog = false
            this.purchase_total_amount = 0
            this.purchaseForm = this.$options.data().purchaseForm
            this.btnDisabled = false
        },

        //新增代采确定事件
        handleClickAddPurchaseConfirm() {
            let newArr = [];
            this.purchaseForm.purchase_details.forEach((item, index) => {
                item.goods_details.forEach((goods, goods_index) => {
                    let res = this.deepFormValidate(`goods_details_form_${index}_${goods_index}`)
                    newArr.push(res)
                })
            })
            Promise.all(newArr).then(() => {
                if (this.isApproval === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false
                this.btnDisabled = true
                purchaseAdd({
                    order_id: this.order_id,
                    ...this.purchaseForm,
                    order_updated_at: this.order_detail.updated_at,
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('新增成功')
                        this.addPurchaseDialog = false
                        this.getPurchaseList()
                        this.$emit('refresh')
                        this.handleClickAddPurchaseCancel()
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }).catch(error => {
                if (Object.keys(error) && Object.keys(error)[0]) {
                    this.$message.error(error[Object.keys(error)[0]][0].message)
                } else {
                    this.$message.error('请输入必填项')
                }
            })
        },

        //点击编辑代采
        handleClickEditPurchase(row) {
            this.order_purchase_id = row.order_purchase_id
            this.purchasePrice = parseFloat(this.order_detail.purchase_cost_price)
            this.purchase_total_amount = parseFloat(row.actual_total_price)
            purchaseDetails({
                order_purchase_id: row.order_purchase_id
            }).then(res => {
                if (res.code === 200) {
                    this.purchaseForm.total_price = res.data.total_price
                    this.purchaseForm.actual_total_price = res.data.actual_total_price
                    this.purchaseForm.discount_price = res.data.discount_price
                    this.purchaseForm.remarks = res.data.remarks
                    this.purchaseForm.file = res.data.file
                    this.purchaseForm.purchase_details = res.data.purchase_details
                    this.editPurchaseDialog = true
                    getBusinessIsApproval('order_purchase').then(res => {
                        this.isApproval = res
                        if (this.isApproval === 1) {
                            getApprovalNodes({
                                approval_type: 'order_purchase',
                            }).then(res => {
                                if (res.code === 200) {
                                    this.purchaseForm.node_list = res.data
                                    this.$refs.approveProcessSelectRef.set_approval_node_list(res.data)
                                } else {
                                    this.$message.error(res.message)
                                }
                                this.loading = false
                            }).catch(() => {
                                this.loading = false
                            })
                        }
                    })
                } else {
                    this.$message.error(res.message)
                }
            })
        },

        //编辑代采取消事件
        handleClickEditPurchaseCancel() {
            orderHasAfterSale({
                order_id: this.order_id
            }).then(res => {
                if (res.code === 200) {
                    if (res.data.isPendingApproval) {
                        this.$message.error(res.data.tips + '，不允许作废')
                    } else {
                        this.editPurchaseDialog = false
                        this.purchase_total_amount = 0
                        this.purchaseForm = this.$options.data().purchaseForm
                        this.btnDisabled = false
                    }
                }
            })
        },

        //编辑代采确定事件
        handleClickEditPurchaseConfirm() {
            let newArr = [];
            this.purchaseForm.purchase_details.forEach((item, index) => {
                item.goods_details.forEach((goods, goods_index) => {
                    let res = this.deepFormValidate(`goods_details_form_${index}_${goods_index}`)
                    newArr.push(res)
                })
            })
            Promise.all(newArr).then(() => {
                if (this.isApproval === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false
                this.btnDisabled = true
                purchaseEdit({
                    order_id: this.order_id,
                    order_purchase_id: this.order_purchase_id,
                    ...this.purchaseForm,
                    order_updated_at: this.order_detail.updated_at,
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('编辑成功')
                        this.getPurchaseList()
                        this.$emit('refresh')
                        this.handleClickEditPurchaseCancel()
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }).catch(error => {
                if (Object.keys(error) && Object.keys(error)[0]) {
                    this.$message.error(error[Object.keys(error)[0]][0].message)
                } else {
                    this.$message.error('请输入必填项')
                }
            })
        },

        //点击撤销代采
        handleClickRevokePurchase(row) {
            this.$msgbox({
                title: '确认撤销吗？',
                message: '撤销后不可恢复，请谨慎操作！',
                confirmButtonText: '撤销',
                cancelButtonText: '取消',
                confirmButtonClass: 'el-button--danger',
                iconClass: 'iconfont icon-shuoming',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_danger'
            }).then(() => {
                cancelApproval({
                    approval_id: row.approval_id
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('撤销成功')
                        this.getPurchaseList()
                    } else {
                        this.$message.error(res.message)
                    }
                })
            })
        },

        //点击作废代采
        handleClickInvalidate(row) {
            orderHasAfterSale({
                order_id: this.order_id
            }).then(res => {
                if (res.code === 200) {
                    if (res.data.isPendingApproval) {
                        this.$message.error(res.data.tips + '，不允许作废')
                    } else {
                        this.order_purchase_id = row.order_purchase_id
                        this.purchasePrice = parseFloat(this.order_detail.purchase_cost_price) - parseFloat(row.total_price)
                        this.invalidatePurchaseDialog = true
                        this.computedOrderAmountInfo('purchase_price')
                    }
                }
            })
        },

        //代采作废取消事件
        handleClickInvalidatePurchaseCancel() {
            this.invalidatePurchaseDialog = false
            this.cancel_reason = ''
            this.order_purchase_id = 0
            this.purchaseForm.order_price_change = []
        },

        //代采作废确定事件
        handleClickInvalidatePurchaseConfirm() {
            if (this.cancel_reason === '') return this.$message.error('请输入作废原因')
            purchaseCancel({
                order_id: this.order_id,
                order_purchase_id: this.order_purchase_id,
                cancel_reason: this.cancel_reason,
                order_price_change: this.purchaseForm.order_price_change,
                order_updated_at: this.order_detail.updated_at
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success('作废成功')
                    this.getPurchaseList()
                    this.handleClickInvalidatePurchaseCancel()
                    this.$emit('refresh')
                } else {
                    this.$message.error(res.message)
                }
            })
        },

        //点击重新提交代采
        handleClickResubmit(row) {
            orderHasAfterSale({
                order_id: this.order_id
            }).then(res => {
                if (res.code === 200) {
                    if (res.data.isPendingApproval) {
                        this.$message.error(res.data.tips + '，不允许重新提交')
                    } else {
                        this.purchase_total_amount = 0
                        this.purchasePrice = parseFloat(this.order_detail.purchase_cost_price)
                        purchaseDetails({
                            order_purchase_id: row.order_purchase_id
                        }).then(res => {
                            if (res.code === 200) {
                                this.purchaseForm.total_price = res.data.total_price
                                this.purchaseForm.actual_total_price = res.data.actual_total_price
                                this.purchaseForm.discount_price = res.data.discount_price
                                this.purchaseForm.remarks = res.data.remarks
                                this.purchaseForm.file = res.data.file
                                this.purchaseForm.purchase_details = res.data.purchase_details
                                this.computedOrderAmountInfo('purchase_price')
                                this.addPurchaseDialog = true
                                getBusinessIsApproval('order_purchase').then(res => {
                                    this.isApproval = res
                                    if (this.isApproval === 1) {
                                        getApprovalNodes({
                                            approval_type: 'order_purchase',
                                        }).then(res => {
                                            if (res.code === 200) {
                                                this.purchaseForm.node_list = res.data
                                                this.$refs.approveProcessSelectRef.set_approval_node_list(res.data)
                                            } else {
                                                this.$message.error(res.message)
                                            }
                                            this.loading = false
                                        }).catch(() => {
                                            this.loading = false
                                        })
                                    }
                                })
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    }
                }
            })
        },

        //点击删除代采明细
        handleClickDelPurchaseDetails(index) {
            this.purchaseForm.purchase_details.splice(index, 1)
        },

        //点击新增代采列表
        handleClickAddPurchaseList() {
            this.purchaseForm.purchase_details.push({
                supplier: '',
                goods_details: [
                    {
                        goods_name: '',
                        price: '',
                        num: '',
                        subtotal_price: ''
                    }
                ],
                total_amount: ''
            })
        },

        //添加明细
        handleClickAddPurchaseDetails(item) {
            item.goods_details.push({
                goods_name: '',
                price: '',
                num: undefined,
                subtotal_price: ''
            })
        },

        //单价输入框失焦事件
        handleGoodsPriceBlur(goods, purchase) {
            let val = goods.price.replace(/[^\d.\-]/g, '');
            let amount = val ? Math.abs(parseFloat(val)) : 0;
            goods.price = amount.toFixed(2);
            if (goods.price && goods.num) {
                goods.subtotal_price = (goods.price * goods.num).toFixed(2)
            } else {
                goods.subtotal_price = 0
            }
            purchase.total_amount = purchase.goods_details.reduce((sum, obj) => {
                const amount = obj.subtotal_price ? parseFloat(obj.subtotal_price) : 0;
                return sum + amount;
            }, 0)
            this.computedPurchaseTotalPrice()
        },

        //数量输入框失焦事件
        handleGoodsNumBlur(goods, purchase) {
            goods.num = goods.num ? goods.num : 0
            goods.num = Number(goods.num).toFixed(0)
            if (goods.price && goods.num) {
                goods.subtotal_price = (goods.price * goods.num).toFixed(2)
            } else {
                goods.subtotal_price = 0
            }
            purchase.total_amount = purchase.goods_details.reduce((sum, obj) => {
                const amount = obj.subtotal_price ? parseFloat(obj.subtotal_price) : 0;
                return sum + amount;
            }, 0)
            this.computedPurchaseTotalPrice()
        },

        //计算代采总金额
        computedPurchaseTotalPrice() {
            const total = this.purchaseForm.purchase_details.reduce((sum, obj) => {
                const amount = obj.total_amount ? parseFloat(obj.total_amount) : 0;
                return sum + amount;
            }, 0);
            this.purchaseForm.total_price = total.toFixed(2)
            //计算实际代采总金额 = 总优惠金额?订单总金额 - 总优惠金额: 订单总金额
            this.purchaseForm.actual_total_price = this.purchaseForm.discount_price ? (this.purchaseForm.total_price - this.purchaseForm.discount_price).toFixed(2) : this.purchaseForm.total_price
            if (this.addPurchaseDialog) {
                this.purchasePrice = parseFloat(this.order_detail.purchase_cost_price) - (this.purchase_total_amount - (this.purchaseForm.total_price ? parseFloat(this.purchaseForm.total_price) : 0))
            } else {
                this.purchasePrice = parseFloat(this.order_detail.purchase_cost_price) - this.purchase_total_amount + (this.purchaseForm.actual_total_price ? parseFloat(this.purchaseForm.actual_total_price) : 0)
            }
            if (this.purchasePrice !== parseFloat(this.order_detail.purchase_cost_price)) {
                this.computedOrderAmountInfo('purchase_price')
            } else {
                this.purchaseForm.order_price_change = []
            }
        },

        //总优惠金额输入框失焦，计算实际代采总金额
        handleDiscountPriceBlur() {
            let val = this.purchaseForm.discount_price.replace(/[^\d.\-]/g, '');
            let amount = val ? Math.abs(parseFloat(val)) : 0;
            if (amount > Number(this.purchaseForm.total_price)) {
                this.purchaseForm.discount_price = ''
                return this.$message.error('总优惠金额不能大于代采物品总金额')
            }
            this.purchaseForm.discount_price = amount.toFixed(2);
            if (this.purchaseForm.discount_price && this.purchaseForm.total_price) {
                this.purchaseForm.actual_total_price = (this.purchaseForm.total_price - this.purchaseForm.discount_price).toFixed(2)
                if (this.addPurchaseDialog) {
                    this.purchasePrice = parseFloat(this.order_detail.purchase_cost_price) - (this.purchase_total_amount - (this.purchaseForm.actual_total_price ? parseFloat(this.purchaseForm.actual_total_price) : 0))
                } else {
                    this.purchasePrice = parseFloat(this.order_detail.purchase_cost_price) - this.purchase_total_amount + (this.purchaseForm.actual_total_price ? parseFloat(this.purchaseForm.actual_total_price) : 0)
                }
                if (this.purchasePrice !== parseFloat(this.order_detail.purchase_cost_price)) {
                    this.computedOrderAmountInfo('purchase_price')
                } else {
                    this.purchaseForm.order_price_change = []
                }
            }
        },

        //订单金额信息计算
        computedOrderAmountInfo(field_key) {
            this.order_amount_field.forEach(field => {
                if (field.extend.field_formula.includes(field_key)) {
                    const components = field.extend.formula_list.filter(formula => formula.type === 'component' || formula.type === 'product_cost' || formula.type === 'product_total_price' || formula.type === 'purchase_price')
                    if (components.length > 0) {
                        //接口需要的数据
                        const formulaValue = {}
                        components.forEach(component => {
                            if (component.type === 'component') {
                                if (component.field_type === 'order_amount_compute_mode') {
                                    formulaValue[component.field_key] = this.order_detail[component.field_key].value
                                } else if (component.field_type === 'money_compute_mode') {
                                    formulaValue[component.field_key] = this.order_detail[component.field_key].value
                                }
                            } else if (component.type === 'product_cost' || component.type === 'product_total_price') {
                                let filteredGoods = []
                                if (component.commodity_value_config.length === 0) {
                                    filteredGoods = this.order_detail.order_goods.filter(good => !good.order_return_goods_id);
                                    ;
                                } else {
                                    component.commodity_value_config.forEach(config => {
                                        if (config.type === 'category') {
                                            this.order_detail.order_goods.forEach(good => {
                                                if (good.category_id === config.id && !good.order_return_goods_id) {
                                                    filteredGoods.push(good)
                                                }
                                            })
                                        } else if (config.type === 'goods') {
                                            this.order_detail.order_goods.forEach(good => {
                                                if (good.goods_id === config.id && !good.order_return_goods_id) {
                                                    filteredGoods.push(good)
                                                }
                                            })
                                        }
                                    })
                                }
                                if (field.extend.applicable_products !== 'all') {
                                    const typeMap = {sale: 1, lease: 2};
                                    const productType = typeMap[field.extend.applicable_products];
                                    filteredGoods = filteredGoods.filter(item => item.type === productType);
                                }
                                const sumFunc = (sum, item) => sum + (component.type === 'product_cost' ? parseFloat(item.cost_price) * item.num : Number(item.subtotal_price.value));
                                formulaValue[component.field_key] = filteredGoods.reduce(sumFunc, 0);
                            } else if (component.type === 'purchase_price') {
                                formulaValue[component.field_key] = this.purchasePrice
                            }
                        })
                        if (Object.values(formulaValue).length > 0) {
                            let res = calculate(field.extend.field_formula, formulaValue)
                            const amount_change = this.purchaseForm.order_price_change.find(item => item.field_key === field.field_key)
                            if (amount_change) {
                                if (field.extend.num_display_style === '1') {
                                    amount_change.new_value = {
                                        value: Number(res.toFixed(2)),
                                        text: Number(res.toFixed(2)).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }),
                                        value_converted: Number(res.toFixed(2)),
                                        currency: "CNY",
                                    }
                                } else {
                                    amount_change.new_value = {
                                        value: Number(res.toFixed(4)),
                                        text: (Math.floor(Number(res.toFixed(4)) * 10000) / 100).toFixed(2),
                                        value_converted: Number(res.toFixed(4)),
                                        currency: "CNY",
                                    }
                                }
                            } else {
                                const price_change = {
                                    field_name: field.field_name,
                                    field_key: field.field_key,
                                    old_value: this.order_detail[field.field_key] ? this.order_detail[field.field_key] : {},
                                    new_value: {
                                        value: 0,
                                        text: "",
                                        value_converted: "",
                                        currency: "CNY",
                                    },
                                }
                                if (field.extend.num_display_style === '1') {
                                    price_change.new_value.value = Number(res.toFixed(2))
                                    price_change.new_value.text = price_change.new_value.value.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })
                                    price_change.new_value.value_converted = Number(res.toFixed(2))
                                } else {
                                    price_change.new_value.value = Number(res.toFixed(4))
                                    price_change.new_value.text = (Math.floor(price_change.new_value.value * 10000) / 100).toFixed(2)
                                    price_change.new_value.value_converted = Number(res.toFixed(4))
                                }
                                this.purchaseForm.order_price_change.push(price_change)
                            }
                        }
                    }
                }
            })
        },

        deepFormValidate(name) {
            const that = this
            return new Promise(function (resolve, reject) {
                if (Array.isArray(that.$refs[name])) {
                    that.$refs[name][0].validate((valid, error) => {
                        if (valid) {
                            resolve();
                        } else {
                            reject(error)
                        }
                    })
                } else {
                    that.$refs[name].validate((valid, error) => {
                        if (valid) {
                            resolve();
                        } else {
                            reject(error)
                        }
                    })
                }
            })
        },

        //上传文件
        handleUploadFileChange(e) {
            const files = e.target.files
            const that = this;
            Array.from(files).forEach(file => {
                if (file.size > 50 * 1024 * 1024) return that.$message.error('附件大小不能超过50m')
                uploadImg(file, file.size).then(res => {
                    if (res.file_path) {
                        res.file_size = formatFileSize(file.size)
                        this.purchaseForm.file.push(res)
                        e.target.value = ''
                    }
                    e.target.value = ''
                }).catch(error => {
                    e.target.value = ''
                })
            })
        },

        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes('image')) {
                this.previewImgList = [file.file_path]
                this.previewImgSrc = file.file_path
                this.$refs.preview_img.showViewer = true
            } else {
                if (file.file_type.includes('pdf')) {
                    window.open(file.file_path)
                } else {
                    this.$message.error('当前文件格式不支持预览，请下载后查看')
                }
            }
        },

        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },
    },
}
</script>
<style lang="scss">
.purchase_detail_dialog {
    .el-dialog {
        height: 720px;

        .el-dialog__body {
            padding: 16px 24px;
        }
    }
}

.add_purchase_details_btn {
    text-align: center;
    border-radius: 4px;
    border: 1px dashed #2990FF;
    color: #2990FF;
    cursor: pointer;
    line-height: 24px;
    height: 24px;
    font-size: 12px;
}

.add_purchase_btn {
    text-align: center;
    border-radius: 4px;
    border: 1px dashed #2990FF;
    color: #2990FF;
    cursor: pointer;
    line-height: 32px;
    height: 32px;
}

.invalidate_purchase_dialog {
    .el-dialog {
        height: 452px;

        .el-dialog__body {
            padding: 24px;
        }
    }
}

.invalidate_title {
    font-size: 14px;
    font-weight: 700;
    line-height: 22px;
    color: #333333;
    margin-bottom: 4px;
}

.invalidate_text {
    line-height: 22px;
    color: #999999;
}

textarea {
    resize: unset;
}

.cancel_icon {
    margin-right: 4px;

    .icon-guanbi1 {
        color: #E96769 !important;
    }
}

.purchase_status_name {
    color: #666666;

    &::before {
        content: '';
        width: 6px;
        height: 6px;
        border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
        margin-right: 4px;
    }

    &.purchase_status_name_0::before {
        background: #F0AA32;
    }

    &.purchase_status_name_1::before {
        background: #5AB333;
    }

    &.purchase_status_name_2::before {
        background: #E44144;
    }

    &.purchase_status_name_3::before {
        background: #BFBFBF;
    }
}

.custom_detail_form {
    .goods_details_index {
        font-size: 12px !important;
        line-height: 18px !important;
        color: #999999 !important;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
</style>